

















































































import {
  DownloadManagerService as api,
  EventManagementEventService as zipApi,
  ZipManagementNotifyService,
} from "@/common/api";
import { default as qNotify, default as QNotify } from "@/common/qNotify";
import QPaginate from "@/common/qPaginate.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import QMultiSelect from "@/components/common/qMultiSelect.vue";
import qSelectEvents from "@/components/common/qSelectEvents.vue";
import PaginateModel from "@/model/paginate";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { Component, Vue } from "vue-property-decorator";

enum status {
  PROGRESS = "progress",
  GENERATED = "generated",
  DELETE = "delete",
  ERROR = "error",
}

@Component({
  name: "DownloadListComponent",
  components: {
    QTableHeader,
    QPaginate,
    QMultiSelect,
    qSelectEvents,
  },
})
export default class DowmnloadListComponent extends Vue {
  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });

  public initSearch = {
    statuses: ["all"],
    name: "",
    sort: "created_at",
    direction: "desc",
    perPage: 30,
    currentPage: 1,
  };

  public searchParams: any = {};
  public isGoogleAuth = false;
  public youtube = {};
  public hasYoutubeError = false;
  public intervalId = null;

  public initHeaders = [
    { id: "updated_at", name: "生成日時", order: "desc" },
    { id: "created_by", name: "登録者", order: "" },
    { id: "type", name: "種別", order: "" },
    { id: "created_by", name: "関連データ", order: "" },
    { id: "name", name: "署名" },
    { id: "name", name: "発行日" },
    { id: "name", name: "コード表示" },
    { id: "name", name: "価格表示" },
    { id: "", name: "" },
    { id: "", name: "" },
  ];

  public selectedAllStatus = { id: "all", name: "すべてのステータス" };
  public statuses = [
    ...[this.selectedAllStatus],
    {
      id: this.zipStatuses.PROGRESS,
      name: "生成中",
    },
    {
      id: this.zipStatuses.GENERATED,
      name: "生成済",
    },
  ];

  public headers = [];

  public contents = [];

  public connection: WebSocket;
  public connectionId = null;

  public mounted() {
    this.headers = JSON.parse(JSON.stringify(this.initHeaders));
    this.filterData();
    window.subscribe("zipFile.updateStatus", (data) => {
      if (data.id) {
        this.contents.map((item) => {
          if (item.id === data.id) {
            item.status = data.status;
          }
          return item;
        });
      }
    });
  }
  public created() {}

  public get zipStatuses() {
    return status;
  }

  public clickSearch() {
    this.searchParams.page = 1;
    this.filterData();
  }

  public filterData(clear = false, addition = {}): void {
    let { name, params, query } = this.$router.currentRoute;

    if (query.statuses) {
      if (typeof query.statuses === "string") {
        query.statuses = [query.statuses as string];
      } else if (typeof query.statuses === "object") {
        query.statuses = query.statuses as string[];
      }
    }

    if (clear) {
      query = {};
    }
    query = {
      ...this.initSearch,
      ...query,
      ...this.searchParams,
      ...addition,
    };
    this.$router
      .replace({ name, params, query })
      .catch((error) => {
        console.error(error);
      });
    this.searchParams = query;
    this.doSearch(query);
  }

  public doSearch(query: any = {}): void {
    const statuses = query.statuses;
    if (statuses === "all") {
      query.statuses = ["all"];
    }
    this.getList(query);
    if (this.$el.querySelector(".mb__responsive-table")) {
      this.$el.querySelector(".mb__responsive-table").scrollTop = 0;
    }
  }

  public async getList(query) {
    let message: any;
    try {
      const result = await api.adminDownload(query);
      this.pagination = new PaginateModel({
        page: result.data.paginator.currentPage,
        pageCount: result.data.paginator.lastPages,
        start: result.data.paginator.currentPage,
        end: result.data.paginator.lastPages,
        count: result.data.paginator.total,
      });
      this.contents = result.data.contents;
    } catch (error) {
      message = error.body.message;
      QNotify.error({
        text: message,
      });
    }
  }

  public resetSearch() {
    this.clearSearchParams();
    this.filterData(true);
  }

  public clearSearchParams() {
    this.searchParams = { ...this.initSearch };
  }

  public displayBoolean(value): string {
    if (value === "1") {
      return "はい";
    }

    return "いいえ";
  }

  public getTypeName(type: string): string {
    switch (type) {
      case "event_cert":
        return "イベント証明書";
      case "event_image":
        return "イベント写真";
      case "koisale_cert":
        return "錦鯉販売証明書";
      case "live_cert":
        return "ライブ鯉証明書";

      default:
        return type;
    }
  }

  public async downloadContent(content) {
    if (content.status !== this.zipStatuses.GENERATED) { return; }

    try {
      const {
        data: { url },
      } = await zipApi.adminEventExportZip({
        id: content.id,
      });
      window.open(url, "_blank", "noreferrer");
    } catch (error) {
      qNotify.error({
        text: error.body.message,
      });
      this.contents.map((item) => {
        if (item.id === content.id) {
          item.status = status.DELETE;
        }
        return item;
      });
    }
  }

  public async retryGenerate(content) {
    let message = `${this.getTypeName(content.type)} を再生成します。`;
    if (content.description !== "---") {
      message = `${content.description} の ${message}`;
    }

    this.$modal.show({
      title: "コンテンツ生成の再実行",
      text: message,
      onConfirm: async () => {
        await ZipManagementNotifyService.zipNotifyReGenerate({
          id: content.id,
        }).then(() => {
          content.status = status.PROGRESS;
        });
      },
      confirmText: "再生成",
    });
  }

  public beforeDestroy() {
    if (!this.connection) { return; }
    this.connection.close();
    this.connection = null;
  }
}
